"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmailDomain = void 0;
var email_1 = require("./email");
Object.defineProperty(exports, "validateEmailDomain", { enumerable: true, get: function () { return email_1.validateEmailDomain; } });
